import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import Typography from 'src/common/components/Typography';
import Button from 'src/common/components/ButtonDS22';
import { NEXT_STATIC_IMAGES, PATHS } from 'src/common/constants';
import ImgFromSrcSet from 'src/common/components/ImgFromSrcSet';
import styles from './ForOwners.module.scss';

const ForOwners: FC = () => {
  const [t] = useTranslation('home-page');

  return (
    <PitchPageLayout backgroundColor="ivory">
      <div className={styles.root}>
        <div className={styles.copySection}>
          <div className={styles.title}>
            <Typography
              type="h2"
              size="display-5"
              sizeFromBreakpointM="display-4"
            >
              {t('for-owners--title')}
            </Typography>
          </div>
          <div className={styles.subTitle}>
            <Typography type="p" size="body-l" sizeFromBreakpointM="body-xl">
              {t('for-owners--subtitle')}
            </Typography>
          </div>
          <div className={styles.buttonWrapper}>
            <div className={styles.button}>
              <Button
                href={PATHS.ADMIN_LISTINGS}
                type="link"
                fitWidth="m"
              >
                {t('start-today')}
              </Button>
            </div>
            <div className={styles.button}>
              <Button
                href={PATHS.FOR_OWNERS}
                type="link"
                variant="tertiary-white"
                fitWidth="m"
              >
                {t('learn-more')}
              </Button>
            </div>
          </div>
        </div>
        <div className={styles.imageSection}>
          <ImgFromSrcSet
            src={`${NEXT_STATIC_IMAGES}home-page/owner-image_extra-small.png`}
            alt={t('for-owners--alt-text')}
            srcSet={[
              [
                1440, 526, 432,
                `${NEXT_STATIC_IMAGES}home-page/owner-image_extra-extra-large.png`,
              ],
              [1200, 486, 399, `${NEXT_STATIC_IMAGES}home-page/owner-image_extra-large.png`],
              [1024, 406, 399, `${NEXT_STATIC_IMAGES}home-page/owner-image_large.png`],
              [768, 598, 399, `${NEXT_STATIC_IMAGES}home-page/owner-image_medium.png`],
              [414, 574, 435, `${NEXT_STATIC_IMAGES}home-page/owner-image_small.png`],
              [0, 287, 218, `${NEXT_STATIC_IMAGES}home-page/owner-image_extra-small.png`],
            ]}
          />
        </div>
      </div>
    </PitchPageLayout>
  );
};

export default ForOwners;
